import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { FiPhone, FiMail, FiClock } from "react-icons/fi";
import { Link } from "react-router-dom";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    console.log("Form Data:", formData);

    setTimeout(() => {
      setSubmitted(false);
      setFormData({});
    }, 3000);
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <Helmet>
        <title>Contact Us | Azz Enterprise</title>
        <meta name="description" content="Reach out to our friendly team for support" />
      </Helmet>

      <NavBar />

      <main className="flex-grow-1">
        <Container className="py-5">
          <Row className="align-items-start g-5">

            <Col lg={5}>
              <div className="mb-4">
                <h2 className="fw-bold mb-3">Let’s Connect</h2>
                <p className="text-muted">We're here to help you. Please reach out using the form or contact info below.</p>
              </div>

              <div className="d-flex align-items-start mb-4">
                <FiMail className="text-primary me-3 fs-4" />
                <div>
                  <h6 className="fw-semibold mb-1">Email Support</h6>
                  <a href="mailto:support@azz.com" className="text-decoration-none">support@azz.com</a>
                </div>
              </div>

              <div className="d-flex align-items-start mb-4">
                <FiPhone className="text-primary me-3 fs-4" />
                <div>
                  <h6 className="fw-semibold mb-1">Phone</h6>
                  <a href="tel:+15551234567" className="text-decoration-none">+1 (555) 123-4567</a>
                </div>
              </div>

              <div className="d-flex align-items-start mb-4">
                <FiClock className="text-primary me-3 fs-4" />
                <div>
                  <h6 className="fw-semibold mb-1">Business Hours</h6>
                  <p className="mb-0">Mon - Fri: 9:00 AM - 6:00 PM</p>
                </div>
              </div>
            </Col>

            <Col lg={7}>
              {submitted && <Alert variant="success">Your message has been sent successfully!</Alert>}
              <div className="bg-white p-5 shadow rounded-4">
                <h4 className="fw-bold mb-4">Send us your message</h4>
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Col>
                      <Form.Control
                        name="firstName"
                        placeholder="First name"
                        value={formData.firstName || ""}
                        onChange={handleChange}
                        required
                      />
                    </Col>
                    <Col>
                      <Form.Control
                        name="lastName"
                        placeholder="Last name"
                        value={formData.lastName || ""}
                        onChange={handleChange}
                        required
                      />
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="you@gmail.com"
                      value={formData.email || ""}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="tel"
                      name="phone"
                      placeholder="(+65) 8123 4567"
                      value={formData.phone || ""}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      name="company"
                      placeholder="Company (optional)"
                      value={formData.company || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      name="message"
                      rows={3}
                      placeholder="Your message"
                      value={formData.message || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Check
                      required
                      type="checkbox"
                      id="privacyCheck"
                      checked={formData.accepted || false}
                      onChange={(e) =>
                        setFormData((prev) => ({ ...prev, accepted: e.target.checked }))
                      }
                      label={
                        <>
                          I accept the website{" "}
                          <Link to="/privacy-policy" className="text-decoration-underline text-primary fw-medium">
                            privacy policy
                          </Link>
                          .
                        </>
                      }
                    />
                  </Form.Group>

                  <Button type="submit" variant="primary" className="w-100 rounded-pill py-2">
                    Submit
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col>
              <h5 className="fw-bold mb-3">Our Location</h5>
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.8954790177553!2d-122.08424918469104!3d37.42199977982517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb0d51fd9fbb5%3A0xc63fa960b0ecf053!2sGoogleplex!5e0!3m2!1sen!2sus!4v1614849876896!5m2!1sen!2sus"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps Embed"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </main>

      <a
        href="https://wa.me/15551234567"
        className="position-fixed bottom-0 end-0 m-4 btn btn-success rounded-circle shadow"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i className="bi bi-whatsapp fs-4"></i>
      </a>

      <Footer />
    </div>
  );
};

export default ContactUs;
